
export class WorkOrderOperationBatchModel {
  barcode: string;
  batch: number;
  amount: number;
  variant: string;
  name: string;
}
